<template>
	<el-container class="page-x" direction="vertical">
		<div class="search-x">
			<div class="search-item">
				<span class="label">用户名</span>
				<el-input
					class="input-box"
					clearable
					v-model.trim="searchBox.loginName"
				></el-input>
			</div>
			<div class="search-item">
				<span class="label">使用人</span>
				<el-input
					class="input-box"
					clearable
					v-model.trim="searchBox.userName"
				></el-input>
			</div>

			<div class="search-item">
				<span class="label">操作模块</span>

				<el-cascader
					placeholder="请选择操作模块"
					clearable
					v-model="searchBox.actionName"
					:options="actionNameList"
					:props="{
						value: 'name',
						label: 'name',
						emitPath: true,
					}"
					@change="cascader($event)"
				></el-cascader>
			</div>
			<div class="search-item">
				<span class="label">操作时间</span>
				<el-date-picker
					v-model="timeCache.treatmentTime"
					@change="
						(e) =>
							toChangeTime(e, 'createTimeBegin', 'createTimeEnd')
					"
					type="daterange"
					value-format="timestamp"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="{
						disabledDate(time) {
							return time.getTime() > Date.now();
						},
					}"
				>
				</el-date-picker>
			</div>

			<el-button
				v-auth="'sa_role_index'"
				type="primary"
				class="search-btn"
				@click="search"
				>查询</el-button
			>
			<el-button
				class="search-btn"
				v-auth="'sa_item_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>
		</div>
		<div class="table-x" ref="tableBox">
			<el-table
				v-loading="loading"
				:data="tableData"
				:height="tableHeight"
				border
				class="mb10"
			>
				<el-table-column
					prop="id"
					align="center"
					label="序号"
					width="100"
				/>
				<el-table-column
					prop="loginName"
					align="center"
					label="用户名"
					width="140"
				/>
				<el-table-column
					prop="userName"
					align="center"
					label="使用人"
					width="140"
				/>

				<el-table-column prop="email" align="center" label="邮箱" />
				<el-table-column
					prop="ip"
					align="center"
					label="ip"
					width="140"
				/>
				<el-table-column prop="content" align="center" label="操作描述">
					<template slot-scope="scope">
						<div
							@click="upDown(scope)"
							:class="{
								upHeight: true,
								downHeight:
									upindex == scope.$index && !rotatHeight,
							}"
						>
							{{
								scope.row.content
									? scope.row.action + "-" + scope.row.content
									: scope.row.action
							}}
						</div>
						<div>
							<span
								v-if="
									(scope.row.action + scope.row.content)
										.length > 50
								"
								@click="upDown(scope)"
								:class="{
									up: rotatHeight,
									down:
										upindex == scope.$index && !rotatHeight,
								}"
								>></span
							>
						</div>
					</template>
				</el-table-column>

				<el-table-column
					prop="createTime"
					align="center"
					label="时间"
					width="160"
				>
					<template slot-scope="scope">
						{{ scope.row.createTime | dateFormat("Y-m-d H:i:s") }}
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 分页部分 -->
		<div class="pagination">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page.sync="searchBox.pageNo"
				@size-change="getData"
				:page-sizes="[10, 50, 100]"
				:page-size.sync="searchBox.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				background
			>
			</el-pagination>
		</div>
	</el-container>
</template>

<script>
	import { dateFormat } from "@/assets/js/until.js";
	import _ from "lodash";
	export default {
		data() {
			return {
				searchBox: {
					loginName: "",
					userName: "",
					actionName: "",
					createTimeBegin: "",
					createTimeEnd: "",
					pageNo: 1,
					pageSize: 20,
				},
				rotatHeight: true,
				actionNameList: [],
				tableHeight: 0,
				upindex: -1,
				loading: false,
				tableData: [],
				total: 0,
				timeCache: {}, // 时间缓存
				dialogLoading: false,
			};
		},
		created() {
			this.$root.breadList = [
				{ name: "系统管理", link: "" },
				{ name: "操作日志", link: "" },
			];
		},
		mounted() {
			this.$nextTick(() => {
				this.listenWindow();
				this.getData();
				const _list = _.chain(
					JSON.parse(sessionStorage.getItem("authMenu"))
				)
					.map((item) => ({
						name: item.meta.title + " ",
						children: _.chain(item.children)
							.map((i) => ({
								name: i.meta.title,
							}))
							.value(),
					}))
					.value();
				_list.unshift({ name: "登录系统" });
				this.actionNameList = _list;
			});
		},
		methods: {
			upDown(i) {
				this.upindex = i.$index;
				this.rotatHeight = !this.rotatHeight;
				if (this.upindex == i.$index) {
				} else {
					this.upindex = -1;
				}
			},
			//窗口改变，重新取得高度
			listenWindow() {
				this.tableHeight = this.$refs.tableBox.offsetHeight;
				window.addEventListener("resize", () => {
					clearTimeout(this.resizeFlag);
					this.resizeFlag = setTimeout(() => {
						try {
							this.tableHeight = this.$refs.tableBox.offsetHeight;
						} catch (error) {}
					}, 300);
				});
			},
			cascader(e) {
				this.searchBox.actionName = e;
			},
			search() {
				this.searchBox.pageNo = 1;
				this.getData();
			},
			getData() {
				this.loading = true;
				let searchBoxParams = _.chain(this.searchBox).cloneDeep().value();
				searchBoxParams.actionName = _.chain(searchBoxParams.actionName)
					.cloneDeep()
					.toString()
					.replace(",", "-")
					.replace(" ", "")
					.value();
				searchBoxParams = _.pickBy(searchBoxParams, _.identity);
				this.axios
					.post(this.getApiUrl("getLogPage"), searchBoxParams, {
						toJSON: true,
					})
					.then((res) => {
						this.loading = false;
						if (res.code === 1) {
							this.tableData = res.data.data || [];
							this.total = res.data.total;
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
					});
			},

			handleCurrentChange(val) {
				this.searchBox.pageNo = val;
				this.getData();
			},
			/**
			 * 时间回调函数
			 */
			toChangeTime(val, createTimeBegin, createTimeEnd) {
				if (val && val.length) {
					this.searchBox[createTimeBegin] = val[0];
					this.searchBox[createTimeEnd] = val[1];
				} else {
					this.searchBox[createTimeBegin] = "";
					this.searchBox[createTimeEnd] = "";
				}
			},
		},
	};
</script>

<style lang="scss" scoped type="text/scss">
	.upHeight {
		overflow: hidden;

		text-overflow: ellipsis;

		display: -webkit-box;

		-webkit-box-orient: vertical;

		-webkit-line-clamp: 3;
	}
	.downHeight {
		height: auto !important;
		-webkit-line-clamp: inherit !important;
	}
	.up {
		// transform: rotate(-90deg) scaleY(1.5);
		display: inline-block;
	}
	.down {
		transform: rotate(90deg) scaleY(1.5);
		display: inline-block;
	}
	// }
</style>